import { render, staticRenderFns } from "./MyAppointBusiness.vue?vue&type=template&id=2e99bf06&scoped=true&"
import script from "./MyAppointBusiness.vue?vue&type=script&lang=js&"
export * from "./MyAppointBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MyAppointBusiness.vue?vue&type=style&index=0&id=2e99bf06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e99bf06",
  null
  
)

export default component.exports